{
  "name": "@sveltia/cms",
  "version": "0.171.0",
  "description": "Sveltia CMS is a modern, lightweight, Git-based headless content management system.",
  "keywords": [
    "svelte",
    "cms",
    "content-management-system"
  ],
  "homepage": "https://sveltiacms.app/en/",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/sveltia/sveltia-cms.git"
  },
  "funding": {
    "type": "github",
    "url": "https://github.com/sponsors/kyoshino"
  },
  "license": "MIT",
  "author": {
    "name": "Kohei Yoshino",
    "url": "https://github.com/kyoshino"
  },
  "type": "module",
  "scripts": {
    "build": "vite build",
    "build:watch": "vite build --watch",
    "check": "pnpm run '/^check:.*/'",
    "check:audit": "pnpm audit --ignore-registry-errors",
    "check:cspell": "cspell --no-progress",
    "check:eslint": "eslint .",
    "check:imports": "node scripts/find-unused-imports.js",
    "check:oxlint": "oxlint .",
    "check:prettier": "prettier --check .",
    "check:stylelint": "stylelint '**/*.{css,scss,svelte}'",
    "check:svelte": "svelte-check",
    "dev": "vite",
    "format": "prettier --write .",
    "prepublishOnly": "vite build",
    "preview": "vite preview",
    "test": "NODE_OPTIONS=--no-experimental-webstorage vitest run",
    "test:coverage": "NODE_OPTIONS=--no-experimental-webstorage vitest run --coverage",
    "test:watch": "NODE_OPTIONS=--no-experimental-webstorage vitest"
  },
  "dependencies": {
    "@jsquash/webp": "^1.5.0",
    "@lexical/markdown": "^0.47.0",
    "@sindresorhus/transliterate": "^2.3.1",
    "@sveltia/i18n": "^1.1.3",
    "@sveltia/ui": "^0.44.0",
    "@sveltia/utils": "^0.10.7",
    "create-react-class": "^15.7.0",
    "dayjs": "^1.11.21",
    "deepmerge": "^4.3.1",
    "exifr": "^7.1.3",
    "fast-deep-equal": "^3.1.3",
    "flat": "^6.0.1",
    "immutable": "^5.1.9",
    "isomorphic-dompurify": "^3.18.0",
    "leaflet": "^1.9.4",
    "lexical": "^0.47.0",
    "marked": "^18.0.6",
    "marked-bidi": "^1.0.15",
    "mime": "^4.1.0",
    "parse-entities": "^4.0.2",
    "pdfjs-dist": "^6.1.200",
    "qrcode": "^1.5.4",
    "react": "^19.2.7",
    "react-dom": "^19.2.7",
    "sanitize-filename": "^1.6.4",
    "smol-toml": "^1.7.0",
    "svgo": "^4.0.2",
    "terra-draw": "^1.32.0",
    "terra-draw-leaflet-adapter": "1.0.3",
    "turndown": "^7.2.4",
    "yaml": "^2.9.0"
  },
  "devDependencies": {
    "@stylistic/eslint-plugin": "^5.10.0",
    "@sveltejs/vite-plugin-svelte": "^7.2.0",
    "@types/leaflet": "^1.9.21",
    "@types/node": "^26.1.1",
    "@types/qrcode": "^1.5.6",
    "@types/react": "^19.2.17",
    "@types/react-dom": "^19.2.3",
    "@vitest/coverage-v8": "^4.1.10",
    "cspell": "^10.0.1",
    "eslint": "^9.39.5",
    "eslint-config-airbnb-extended": "^3.1.1",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-jsdoc": "^63.0.13",
    "eslint-plugin-package-json": "^1.6.0",
    "eslint-plugin-svelte": "^3.20.0",
    "eslint-plugin-unused-imports": "^4.4.1",
    "globals": "^17.7.0",
    "oxlint": "^1.74.0",
    "postcss-html": "^1.8.1",
    "prettier": "^3.9.5",
    "prettier-plugin-svelte": "^4.1.1",
    "stylelint": "^17.14.0",
    "stylelint-config-recommended": "^18.0.0",
    "svelte": "^5.56.5",
    "svelte-check": "^4.7.2",
    "ts-json-schema-generator": "^2.9.0",
    "typescript": "^6.0.3",
    "vite": "^8.1.4",
    "vitest": "^4.1.10"
  },
  "publishConfig": {
    "directory": "package",
    "access": "public",
    "provenance": true
  }
}
